import app from 'firebase/app'


const firebaseConfig = {
    apiKey: "AIzaSyBOPUnwgu4baADJY3NCB2aEql1Dz8yQSFs",
    authDomain: "mktocak.firebaseapp.com",
    databaseURL: "https://mktocak.firebaseio.com",
    projectId: "mktocak",
    storageBucket: "mktocak.appspot.com",
    messagingSenderId: "783479946373",
    appId: "1:783479946373:web:218a76768ea6d3bb197dec",
    measurementId: "G-E3N9H13R61"
  };

  class Firebase {
    constructor() {
      app.initializeApp(firebaseConfig);
      app.analytics();
      this.auth = app.auth();
      this.googleProvider = new app.auth.GoogleAuthProvider();
      this.facebookProvider = new app.auth.FacebookAuthProvider();
      this.twitterProvider = new app.auth.TwitterAuthProvider();
      this.phoneNum = new app.auth.PhoneAuthProvider();
    }

    doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

    doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

    doSignInWithTwitter = () =>
    this.auth.signInWithPopup(this.twitterProvider);

    doSignInWithPhone = (phoneNumber,verifier)=>
    this.auth.signInWithPhoneNumber(phoneNumber,verifier);
 
    doSignOut = () => this.auth.signOut();
 
  }
  
   
  export default Firebase;
  